(function () {
  var variantMap = {
    'S/Black':  53586996035768, 'S/Red':  53586996068536,
    'M/Black':  53586996101304, 'M/Red':  53586996134072,
    'L/Black':  53586996166840, 'L/Red':  53586996199608,
    'XL/Black': 53586996232376, 'XL/Red': 53586996265144
  };
  var selColor = 'Black', selSize = null, selSizeEl = null;

  function $(id) { return document.getElementById(id); }
  function show(id) {
    var e = $(id); if (!e) return;
    e.classList.add('visible');
    /* play any videos inside this page */
    e.querySelectorAll('video').forEach(function(v) { v.muted = true; v.play().catch(function(){}); });
  }
  function hide(id) { var e = $(id); if (e) e.classList.remove('visible'); }
  function resetColors() {
    var b = $('m-btn-black'); if (b) b.classList.remove('color-selected');
    var r = $('m-btn-red'); if (r) r.classList.remove('color-selected');
  }

  /* Play all m-page videos on load (title page etc) */
  document.querySelectorAll('.m-page video').forEach(function (v) {
    v.muted = true;
    v.play().catch(function () {});
  });

  function enableHomeBtns() {
    var s = $('m-shop-btn'); if (s) s.style.pointerEvents = 'auto';
    var v = $('m-videos-btn'); if (v) v.style.pointerEvents = 'auto';
  }

  var titlePage = $('m-title');
  if (titlePage) {
    function goHome() { hide('m-title'); show('m-home'); enableHomeBtns(); }
    titlePage.addEventListener('touchend', function (e) { e.preventDefault(); goHome(); });
    titlePage.onclick = goHome;
  }

  var shopBtn = $('m-shop-btn');
  if (shopBtn) shopBtn.onclick = function () { hide('m-home'); show('m-shop'); };

  var videosBtn = $('m-videos-btn');
  if (videosBtn) videosBtn.onclick = function () {
    hide('m-home'); show('m-videos');
    var f = $('m-yt-frame');
    if (f && f.src === 'about:blank') f.src = f.dataset.src;
  };

  var shopBack = $('m-shop-back');
  if (shopBack) shopBack.onclick = function () { hide('m-shop'); show('m-home'); enableHomeBtns(); };

  var blackZone = $('m-black-zone');
  if (blackZone) blackZone.onclick = function () { selColor = 'Black'; hide('m-shop'); show('m-tshirt'); resetColors(); };

  var redZone = $('m-red-zone');
  if (redZone) redZone.onclick = function () { selColor = 'Red'; hide('m-shop'); show('m-tshirt'); resetColors(); };

  var tshirtBtn = $('m-shop-tshirt-btn');
  if (tshirtBtn) tshirtBtn.onclick = function () { selColor = 'Black'; hide('m-shop'); show('m-tshirt'); resetColors(); };

  var tshirtBack = $('m-tshirt-back');
  if (tshirtBack) tshirtBack.onclick = function () { hide('m-tshirt'); show('m-shop'); };

  var videosBack = $('m-videos-back');
  if (videosBack) videosBack.onclick = function () {
    hide('m-videos'); show('m-home'); enableHomeBtns();
    var f = $('m-yt-frame'); if (f) f.src = 'about:blank';
  };

  var btnBlack = $('m-btn-black');
  if (btnBlack) btnBlack.onclick = function () {
    if (this.classList.contains('color-selected')) { this.classList.remove('color-selected'); selColor = null; }
    else { resetColors(); this.classList.add('color-selected'); selColor = 'Black'; }
  };

  var btnRed = $('m-btn-red');
  if (btnRed) btnRed.onclick = function () {
    if (this.classList.contains('color-selected')) { this.classList.remove('color-selected'); selColor = null; }
    else { resetColors(); this.classList.add('color-selected'); selColor = 'Red'; }
  };

  document.querySelectorAll('.m-size-btns img').forEach(function (img) {
    img.onclick = function () {
      if (selSizeEl && selSizeEl !== img) selSizeEl.classList.remove('sz-selected');
      if (img.classList.contains('sz-selected')) {
        img.classList.remove('sz-selected'); selSizeEl = null; selSize = null;
      } else {
        img.classList.add('sz-selected'); selSizeEl = img; selSize = img.dataset.size;
      }
    };
  });

  var tshirtCta = $('m-tshirt-cta');
  if (tshirtCta) tshirtCta.onclick = function () {
    if (!selSize || !selColor) {
      var c = this; c.style.filter = 'brightness(0.5)';
      setTimeout(function () { c.style.filter = ''; }, 600);
      return;
    }
    var vid = variantMap[selSize + '/' + selColor];
    if (!vid) return;
    var cta = this;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      cta.style.filter = 'hue-rotate(90deg) brightness(1.3)';
      setTimeout(function () { cta.style.filter = ''; }, 800);
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var el = $('m-cart-count'); if (el) el.textContent = cart.item_count;
      });
    }).catch(function (e) { console.error('mobile cart:', e); });
  };

  /* Invisible hit zones */
  document.querySelectorAll('.m-hit').forEach(function(div) {
    function fire() {
      var t = document.getElementById(div.dataset.target);
      if (t) t.click();
    }
    div.addEventListener('touchend', function(e) { e.preventDefault(); e.stopPropagation(); fire(); });
    div.onclick = function(e) { e.stopPropagation(); fire(); };
  });
})();
